var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34.8 20.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\uC790\uC0B0 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uB808\\uC774\\uC5B4_2",
    "data-name": "\\uB808\\uC774\\uC5B4 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.6,6.2a.9.9,0,0,1-.7-.3.9.9,0,0,1-.3-.7.6.6,0,0,1,.1-.4l.2-.3a1,1,0,0,1,1.4,0l.2.3c0,.1.1.3.1.4a.9.9,0,0,1-.3.7l-.3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.6,10.4a1,1,0,0,1,1-1h0a1.1,1.1,0,0,1,1,1h0a1,1,0,0,1-1,1h0A.9.9,0,0,1,9.6,10.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.6,16.6a.9.9,0,0,1-.7-.3c-.1-.1-.2-.2-.2-.3a.6.6,0,0,1-.1-.4.8.8,0,0,1,.1-.4l.2-.3.3-.2H11l.3.2.2.3c0,.2.1.3.1.4V16c0,.1-.1.2-.2.3A1.1,1.1,0,0,1,10.6,16.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.8,2V18.7H2v-5a4,4,0,0,0,1.9-3.3A4,4,0,0,0,2,7V2H32.8m2-2H0V8.5a1.9,1.9,0,0,1,1.9,1.9A1.9,1.9,0,0,1,0,12.2v8.5H34.8V0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuy);
export default __webpack_public_path__ + "static/media/buy.2a7c10105e8e90b2435cf18d8eebe02e.svg";
export { ForwardRef as ReactComponent };